import styled from "styled-components";

export const SimilarNodesAssetsViewStyled = styled.div`
  width: 97%;

  .grouped-carasol {
    padding-left: 15px;
  }
`;
